<template>
  <div class="w-100">
    <b-form-checkbox-group
      class="select-input__group w-100"
      buttons
      pill
      :button-variant="`outline-${colorVariant}`"
      stacked
      v-model="selected"
      @input="handleSelect"
    >
      <b-form-checkbox
        v-for="(option, i) in options"
        :key="'option' + i"
        class="select-input__button d-flex align-items-center"
        :value="option.value"
        :disabled="disabled(option)"
      >
        <!-- icon -->
        <div v-if="option.icon" class="select-input__button-icon-wrapper">
          <simple-svg
            :class="
              isSelected(option)
                ? `select-input__button-icon-${colorVariant}`
                : 'select-input__button-icon'
            "
            :src="option.icon"
            width="100%"
            height="100%"
            @load="loaded"
          />
        </div>
        <!-- if no icon we show radio button -->
        <div v-else>
          <div class="d-flex align-items-center">
            <div
              class="d-flex align-items-center select-input__radio"
              :class="buttonClass(option).radio"
            >
              <div
                v-if="isSelected(option)"
                class="button-input__radio-dot"
                :class="buttonClass(option).dot"
              ></div>
            </div>
          </div>
        </div>

        <div v-html="option.label" class="text-left" />
      </b-form-checkbox>
    </b-form-checkbox-group>
  </div>
</template>
<script>
import colorVariantMixin from "@/components/mixins/colorVariantMixin";

export default {
  name: "selectInput",
  mixins: [colorVariantMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      selected: [],
      iconLoaded: false,
    };
  },
  watch: {
    selected() {
      if (this.max && this.max === 1 && this.selected.length > this.max) {
        // manually remove first selection (swap) from v-model, bc if we have max == 1
        // all options are still selectable and on a new select the answer should only be changed
        this.selected.shift();
        this.handleSelect();
      }
      if (this.max && this.max > 1 && this.selected.length > this.max) {
        // manually remove option from v-model if limit is exceeded as there is no
        // native bootstrap option for limiting number of selected checkbox options
        this.selected.pop();
        // TODO: show hint here
      }
    },
  },
  methods: {
    handleSelect() {
      this.$emit("select", this.selected);
    },
    disabled(option) {
      if (this.max === 1) {
        // if we can only select 1 item all others will stay active
        return false;
      }
      return this.selected.length === this.max && this.selected.indexOf(option.value) === -1;
    },
    isSelected(option) {
      return this.selected.indexOf(option.value) !== -1;
    },
    loaded() {
      this.iconLoaded = true;
    },
    buttonClass(option) {
      return {
        radio: this.isSelected(option) ? `border-${this.colorVariant}` : "border-bq-grey-1",
        dot: this.isSelected(option) ? `bg-${this.colorVariant}` : "",
      };
    },
  },
  mounted() {
    if (!this.options.find((option) => option.icon)) {
      this.iconLoaded = true;
    }
  },
};
</script>
<style lang="scss">
.select-input__group {
  outline: 0;
}

.select-input__button {
  min-height: 3rem;
  border-radius: 10px !important;
  margin-bottom: 0.5em !important;
}

.select-input__button-icon-wrapper {
  height: 2em;
  width: 2em;
  margin-right: 10px;
  > * {
    // simple svg apparently doesn't add class to element on first render, so we use child selector
    fill: $main-font-grey;
    max-width: 32px;
    max-height: 32px;
  }
}

.select-input__button-icon {
  &-bq-burgundy {
    fill: $bq-burgundy;
    * {
      fill: $bq-burgundy;
    }
  }
  &-bq-blue {
    fill: $bq-blue;
    * {
      fill: $bq-blue;
    }
  }
  &-bq-green {
    fill: $bq-green;
    * {
      fill: $bq-green;
    }
  }
  &-bq-turquoise {
    fill: $bq-turquoise;
    * {
      fill: $bq-turquoise;
    }
  }
  &-bq-orange {
    fill: $bq-orange;
    * {
      fill: $bq-orange;
    }
  }
  &-bq-red {
    fill: $bq-red;
    * {
      fill: $bq-red;
    }
  }
}

.select-input__radio {
  height: 20px;
  width: 20px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  border: 2px solid;
  margin: 0 1.75rem 0 1rem;
  @media screen and (min-width: 992px) {
    margin: 0 2.75rem 0 1.825rem;
  }
}

.select-input__radio-dot {
  height: 8px;
  width: 8px;
  min-width: 8px;
  min-height: 8px;
  border-radius: 50%;
  margin: 0 auto;
}
</style>
